export default __webpack_public_path__ + "static/media/shareBlack.82f9598b.svg";